export default "__VITE_ASSET__a62f5f45__"